import React from 'react';
// Constants
import {
  CompanyName,
  KeywordsPages,
  LocationCity,
  MainTitle,
} from '../../utils/Constants';
// Data
import {
  dominationPageAdditionalMeta,
  dominationPageStructuredData,
} from '../../utils/data/MetaData';
// Images
import MainImage from '../../assets/images/main/mistress-md-professional-dominatrix-in-red-in-red-dungeon-smoking-banner.jpg';
// Components
import Navbar from '../../components/nav/Navbar';
import { HelmetItem } from '../../components/utils/HelmetItem';
import DominationPageMainContainer from '../../components/domination/DominationPageMainContainer';
import ServiceHeader from '../../components/general/ServiceHeader';
import FooterComponent from '../../components/footer/FooterComponent';

function DominationPage() {
  return (
    <>
      {/* Tab Data */}
      <HelmetItem
        PageName='Domination & BDSM Services'
        desc={`Submit to the irresistible power of ${CompanyName}. Explore my world of control, discipline and indulgence. Tribute, serve and experience true domination.`}
        keywords={KeywordsPages}
        additionalMeta={dominationPageAdditionalMeta}
        structuredData={dominationPageStructuredData}
      />

      {/* Page */}
      <div className='grid min-h-screen overflow-hidden bg-colour1 text-colour2 dark:bg-colour2 dark:text-colour1 font-poppins'>
        {/* Main */}
        <div className=' min-h-screen'>
          {/* Navigation */}
          <Navbar />

          {/* Header */}
          <ServiceHeader
            title={`DOMINATION`}
            subtitle={`Serve me and feel my firm hand!`}
            imageUrl={`bg-domination`}
          />

          {/* Main page content */}
          <DominationPageMainContainer />

          {/* Footer */}
          <FooterComponent />
        </div>
      </div>
    </>
  );
}

export default DominationPage;
